import { Navigate } from "react-router-dom";
import { useOssAuth } from "../../context/OssAuthContext";
import OssSectionPageHeader from "../../components/oss/OssSectionPageHeader";
import MediciCurantiSection from "../../components/doctors/MediciCurantiSection";

export default function OssMedici() {
  const { token, activeOss } = useOssAuth();
  if (!activeOss?.responsabile) {
    return <Navigate to="/oss" replace />;
  }

  return (
    <div className="space-y-4">
      <OssSectionPageHeader
        sectionKey="medici"
        title="Medici curanti"
        subtitle="Anagrafica medici della struttura"
      />
      <MediciCurantiSection
        token={token}
        canManage
        apiBase="/api/oss/me/doctors"
      />
    </div>
  );
}
